import React from 'react';
import PropTypes from 'prop-types';
import QuickTip from '../QuickTip';

const QuickTipSnippet = ({ field }) => {
  switch (field) {
    case 'title':
      return (
        <QuickTip ariaLabel="Press Release Headline Tip">
          We see more of our readers click on short, concise headlines.
          Try using a <b>maximum of 10 to 12 words.</b>
        </QuickTip>
      );
    case 'full_text':
      return (
        <QuickTip ariaLabel="Press Release Content Tips">
          <ul>
            <li>
              <span>
                In accordance with <b>AP style</b>, your dateline and company link will be
                automatically included in your press release.
              </span>
            </li>
            <li>
              <span>
                Concise press releases with an average of <b>800 words or less</b> are most
                useful to readers.
              </span>
            </li>
            <li>
              <span>
                Using bold fonts, Italicized words, thoughtful spacing and indenting can make
                content more <b>“scannable” and memorable</b>.
              </span>
            </li>
            <li>
              <span>
                Including a few <b>quotes from a subject matter expert</b> demonstrates
                authority on the topic.
              </span>
            </li>
          </ul>
        </QuickTip>
      );
    case 'cloudinary_company_logo':
      return (
        <QuickTip ariaLabel="Press Release Company Logo Tips">
          <ul>
            <li>
              <span>
                To ensure your images appear correctly, please check to&nbsp;
                <b>make sure the files meet the recommended dimensions</b>.
              </span>
            </li>
            <li>
              <span>
                <b>Ensure you have the proper right to the image</b> before posting.
              </span>
            </li>
          </ul>
        </QuickTip>
      );
    default:
      return (<></>);
  }
};

QuickTipSnippet.propTypes = {
  field: PropTypes.string.isRequired,
};

export default QuickTipSnippet;
